<mat-toolbar class="header-toolbar">
  <div class="header-brand">
    <img class="logo" src="assets/images/logo.png" alt="logo" />
    <div class="header-brand__text">
      <div class="header-brand__title">{{'e-Sign' | translate}}</div>
      <div class="header-brand__subtitle">{{'DCN Label' | translate}}</div>
    </div>
  </div>

  <span class="header-spacer"></span>

  @if (userData?.firstName) {
    <div class="header-user">
      <div class="header-user__welcome">{{'Welcome' | translate}}</div>
      <div class="header-user__name">{{userData.firstName}} {{userData.lastName}}</div>
    </div>
  }

  <button
    mat-icon-button
    type="button"
    class="header-profile-btn"
    (click)="myProfile()"
    aria-label="View profile"
    >
    <mat-icon matTooltip="{{'ViewProfileTooltip' | translate}}">account_circle</mat-icon>
  </button>

  <button
    mat-button
    type="button"
    class="header-logout-btn"
    (click)="logout()"
    aria-label="Logout"
    >
    {{'Logout' | translate}}
  </button>
</mat-toolbar>
